define('presentation/settings/webChats/presentationObjects/webChatWidgetDomainPresentationObject',[], function() {
    return function(){
        const self = this;

        self.webChatWidgetAuthorizedDomainId = null;
        self.domain = null;
    };
});

